import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchData1 } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function EBIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [year, setYear] = useState("");

    const history = useHistory(); // Access the navigation history

    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [selectedMembers, setSelectedMembers] = useState({});
    const [type, setType] = useState("2");
    const [eventHeadOption, setEventHeadOption] = useState(); // For Event Head
    const [selectedEvent, setSelectedEvent] = useState(""); // Store selected member ID
    const [alleventsbudget, setAllEvents] = useState(true);
    const [selectedeventsbudget, setSelectedEvents] = useState(false);
    const [selectedOption, setSelectedOption] = useState(true);
    const [eventslist, setEventOptions] = useState([]);
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            fetchtableData();
            logout();
            return;
        }

        // Token is not expired, fetch data


    }, [isAuthenticated, clubId, branchId, token, logout]);



    const [financialyear, setFinancialYear] = useState("");
    const [isReadyToFetch, setIsReadyToFetch] = useState(false);
    // const fetchtableData1 = async () => {
    //     try {
    //         setData([]);
    //         const response = await fetchData1('EventBuget', `/${clubId}/${branchId}/${eventHeadOption?.value}/${type}/${financialyear}`, token);

    //         if (response.responseCode === '1111') {
    //             console.log('Fetched Data:', response);
    //             setData(response.response_data);
    //         } else {
    //             console.warn('Response indicates an issue:', response);
    //         }
    //     } catch (error) {
    //         if (error.response) {
    //             console.error('Server Error:', error.response.data);
    //             console.error('Status Code:', error.response.status);
    //         } else if (error.request) {
    //             console.error('No response received:', error.request);
    //         } else {
    //             console.error('Unexpected Error:', error.message);
    //         }
    //     }
    // };


    const fetchtableData = async () => {
        try {
            setData([]);
            const response = await fetchData1('EventBuget', `/${clubId}/${branchId}/${type}/${financialyear}`, token);

            if (response.responseCode === '1111') {
                console.log('Fetched Data:', response);
                setData(response.response_data);
            } else {
                console.warn('Response indicates an issue:', response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
                console.error('Status Code:', error.response.status);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Unexpected Error:', error.message);
            }
        }
    };
    useEffect(() => {
        // Set the current date and initialize financial year
        const currentDate = new Date();
        setYear(currentDate.toISOString().split("T")[0]); // Format as yyyy-MM-dd
        const fy = calculateFinancialYear(currentDate); // Calculate financial year
        setFinancialYear(fy);

        // Set a flag to indicate readiness to fetch data
        setIsReadyToFetch(true);
    }, []);

    // Fetch data only after financial year is set
    useEffect(() => {
        if (isReadyToFetch && financialyear) {
            fetchtableData();
            fetchtableDataEvent();
        }
    }, [isReadyToFetch, financialyear, type]);

    // const handleDropdownChange = (option) => {
    //     setEventHeadOption(option);
    //     fetchtableData1();
    //     setAllEvents(false);
    //     setSelectedEvents(true);

    // };

    const handleDropdownChange = async (option) => {
        if (!option?.value) return;
    
        setEventHeadOption(option);
        setAllEvents(false);
        setSelectedEvents(true);
        setData([]);
    
        try {
            const response = await fetchData1(
                'EventBuget',
                `/${clubId}/${branchId}/${option.value}/${type}/${financialyear}`,
                token
            );
    
            if (response.responseCode === '1111') {
                setData(response.response_data);
            } else {
                console.warn('Response indicates an issue:', response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Unexpected Error:', error.message);
            }
        }
    };
    

    // Function to calculate financial year in 21-22 format
    const calculateFinancialYear = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // getMonth() returns 0-based month

        if (month < 7) {
            // Financial year starts from April
            const prevYear = year - 1;
            return `${prevYear.toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
            const nextYear = year + 1;
            return `${year.toString().slice(-2)}-${nextYear.toString().slice(-2)}`;
        }
    };
    const handleChange = (event) => {
        setType(event.target.value);
        // fetchtableData();
    };

    const fetchtableDataEvent = async () => {
        fetchData('EventApi', `/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(events => ({
                        value: events.id,
                        label: events.event

                    }));
                    setEventOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching Event Details:', error);
            });


    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    EVENT BUDGET</h6>

            </div>

            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-4">

                <div className="flex flex-col">
                    <label htmlFor="year" className="mb-1">To</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={year}
                        onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            setYear(e.target.value);
                            setFinancialYear(calculateFinancialYear(selectedDate));
                        }}
                        type="date"
                        placeholder="Select Date"
                    />
                </div>

                <div className="flex flex-col">
                    <label htmlFor="financialyear" className="mb-1">Financial Year</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={financialyear}
                        readOnly
                        type="text"
                        placeholder="Financial Year"
                    />
                </div>

               {/*<div className="flex flex-col">
                    <label htmlFor="type" className="mb-1">Select Type</label>
                    <select
                        name="type"
                        value={type}
                        onChange={handleChange}
                        className="form-select block w-full py-2 px-3 border rounded text-gray-700 shadow appearance-none focus:shadow-outline"
                    >
                        <option value="2">Expense</option>
                        <option value="1">Income</option>
                    </select>
                </div>*/} 



                <div className="w-1/10 mr-2">
                    <label htmlFor="eventHead">Select Event</label>
                    <Select
                        value={eventHeadOption}
                        onChange={handleDropdownChange}
                        options={eventslist}
                        placeholder="Select Event"
                        isSearchable
                        menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (provided) => ({
                                ...provided,
                                width: "300px", // Default fixed width
                                minWidth: "200px", // Prevents shrinking smaller than this
                                maxWidth: "auto", // Expands if needed
                                cursor: "pointer",
                                whiteSpace: "nowrap"
                            }),
                            menu: (provided) => ({
                                ...provided,
                                width: "auto",
                                minWidth: "300px",
                                whiteSpace: "nowrap",
                                overflowX: "auto", // Allows horizontal scrolling if needed
                                overflowY: "hidden", // Disables vertical scrolling
                                maxHeight: "none"
                            }),

                        }}
                    />
                </div>

            </div>

            {alleventsbudget && (
                <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}>
                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'left'  }}>Sl No</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'left'  }}>Event</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Income Estimate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Expense Estimate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Income Actual</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Expense Actual</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Variance</TableCell>


                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: '#cef1fa' }}>
                                {data.map((event, index) => (

                                    <TableRow
                                        key={index}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fcff', // Alternate row background colors
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px' , textAlign: 'left' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '4px', textAlign: 'left'  }}>
                                        <a
                                            href={`/EventEdit/${event.eventId}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: 'blue' }}
                                        >{event.event}</a></TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.incomeEstimate != null ? event.incomeEstimate.toFixed(2) : '-'}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.expenseEstimate != null ? event.expenseEstimate.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.incomeActual != null ? event.incomeActual.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.expenseActual != null ? event.expenseActual.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.variance != null ? event.variance.toFixed(2) : '-'}
                                        </TableCell>

                                    </TableRow>
                                ))}




                            </TableBody>

                        </Table>
                    </TableContainer>
                </div>
            )}



            {/*selected event splitup table*/}
            {selectedeventsbudget && (
                <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}>
                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' , textAlign: 'left' }}>Sl No</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' , textAlign: 'left' }}>Head</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' , textAlign: 'left' }}>Bill No</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Income Estimate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Expense Estimate</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Income Actual</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Expense Actual</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'Right' }}>Variance</TableCell>


                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: '#cef1fa' }}>
                                {data.map((event, index) => (

                                    <TableRow
                                        key={index}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fcff', // Alternate row background colors
                                        }}
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px' , textAlign: 'left' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '4px' , textAlign: 'left' }}>{event.event}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '4px' , textAlign: 'left' }}>
                                        <a
                                            href={`/PaymentAndReceiptEdit/${event.prId}/0/2`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: 'none', color: 'blue' }}
                                        >{event.billNo}</a></TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.incomeEstimate != null ? event.incomeEstimate.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.expenseEstimate != null ? event.expenseEstimate.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.incomeActual != null ? event.incomeActual.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.expenseActual != null ? event.expenseActual.toFixed(2) : '-'}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '2px', textAlign: 'Right' }}>
                                            {event.variance != null ? event.variance.toFixed(2) : '-'}
                                        </TableCell>

                                    </TableRow>
                                ))}




                            </TableBody>

                        </Table>
                    </TableContainer>
                </div>
            )}


        </div>
    );
}

export default EBIndex;




